import { createComponent } from '@lib/util/templateHelpers';

export default createComponent('Box', {}, function Box ({ className, style }, props) {
  return (
    <div className={className} style={style}>
      {props.children}
    </div>
  );
});
